import wakelock from '@/utils/wakelock'

const actions = {
  requestWakeLockAction: async () => {
    await wakelock.requestWakeLock()
  },
  releaseWakeLockAction: async () => {
    await wakelock.releaseWakeLock()
  },
}

export default actions
